<template>
    <div class="course">
        <div class="mobile-text">
            <div class="mobile-title">Teach:able</div>
            <p>
                <img src="../assets/img/mobile/user-icon.png">
                {{username}}
            </p>
        </div>
        <div class="courses">
            <div class="title">My Courses</div>
            <div class="detail">Manage Teaching and Learning with Ease</div>
            <div class="course-list">
                <div class="course-item" v-for="(userCourseList, index) in userCourseLists" :key="index">
                    <img src="../assets/img/user-interface-logo.png">
                    <div class="course-item-title">{{userCourseList.course_name}}</div>
                    <div class="buttons">
                        <el-button class="update">Update</el-button>
                        <el-button class="start">Start Now</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="suggestion">
            <div class="title">My Suggestion</div>
            <div class="detail">Try more Courses now</div>
            <div class="suggestion-list" >
                <div class="suggestion-item" v-for="course in suggestionCourses" :key="course.key">
                    <div class="suggestion-item-type">Buy</div>
                    <div class="suggestion-item-title">{{course.name}}</div>
                    <div class="suggestion-item-price"><span class="ori"><del>{{course.oriPrice ? "$" + course.oriPrice : ''}}</del></span> ${{course.price}}</div>
                </div>
            </div>
            <div class="mobile-suggestion-list">
                <div class="suggestion-item" v-for="course in suggestionCourses" :key="course.key">
                    <div class="suggestion-item-title">Buy {{course.name}}</div>
                    <div class="suggestion-item-price"><span class="ori"><del>{{course.oriPrice ? "$" + course.oriPrice : ''}}</del></span> ${{course.price}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Course",
        data() {
            return {
                /* user course */
                userCourseLists:[],
                courseForm: {
                    page: 1,
                    page_size: 50
                },
                /* Suggestion */
                suggestionCourses:[],
                suggestionForm: {
                    type: 'course',
                    page: 1,
                    page_size: 50,
                },
            }
        },
        mounted () {
            this.init();
        },
        methods: {
            init() {
                this.$api.request('User/info').then((result) => {
                    if (result.status == true) {
                        let results = result.data;
                        this.username = results.name;
                    } else {
                        this.$message.error(result.msg);
                    }
                }).catch(error => {
                    this.$message.error(error.msg);
                });

                this.getSuggestionList();
                this.getUserCourseList();
            },
            /* user course */
            getUserCourseList() {
                this.$api.request('User/getCourseList', this.courseForm).then((result) => {
                    if (result.status == true) {
                        console.log(result.data);
                        this.userCourseLists = result.data.list;
                    } else {
                        this.$message.error(result.msg);
                    }
                }).catch(error => {
                    this.$message.error(error.msg);
                });
            },
            /* Suggestion */
            getSuggestionList() {
                this.$api.request('System/getSuggestionList', this.suggestionForm).then((result) => {
                    if (result.status == true) {
                        this.suggestionCourses = result.data.list;
                    } else {
                        this.$message.error(result.msg);
                    }
                }).catch(error => {
                    this.$message.error(error.msg);
                });
            }
        },
    }
</script>

<style lang='scss' type='text/css'>
    @import "../styles/pc/MyCourse.scss";
    @import "../styles/mobile/MyCourse.scss";
</style>
